import { Theme } from '@mui/material/styles';
//
import { CloseIcon } from './CustomIcons';

// ----------------------------------------------------------------------

declare module '@mui/material/styles' {
  interface CustomSize {
    large: string;
  }
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module '@mui/material/Chip' {
  interface ChipPropsSizeOverrides {
    large: true;
  }
  interface ChipPropsColorOverrides {
    darkGreenContentment: true;
    lightGrey: true;
  }
}

export default function Chip(theme: Theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        root: {
          ...theme.typography.badge,
          padding: theme.spacing(0.5),
          color: `${theme.palette.text.primary} !important`,
          '& .MuiSvgIcon-root': {
            width: 30,
            height: 30,
            background: 'transparent',
          }
        },
        sizeLarge: {
          fontSize: 14,
          height: theme.spacing(6),
          borderRadius: 50,
          '& .MuiSvgIcon-root': {
            marginLeft: theme.spacing(1),
            width: 35,
            height: 35,
          }
        },
        colorDefault: {
          backgroundColor: theme.palette?.branded?.paper,
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
          '&:hover': {
            backgroundColor: theme.palette?.branded?.paper,
          }
        },
        avatar: {
          padding: theme.spacing('4px', 0),
        },
        filled: {
          color: 'inherit',
          '&.MuiChip-colorInfo': {
            backgroundColor: theme.palette.info.light,
            color: `${theme.palette.info.darker} !important`,
          },
          '&.MuiChip-colorSuccess': {
            backgroundColor: theme.palette.success.light,
            color: `${theme.palette.success.darker} !important`,
          },
          '&.MuiChip-colorWarning': {
            backgroundColor: theme.palette.warning.light,
            color: `${theme.palette.warning.darker} !important`,
          },
          '&.MuiChip-colorError': {
            backgroundColor: theme.palette.error.light,
            color: `${theme.palette.error.darker} !important`,
          },
          '&.MuiChip-colorDarkGreenContentment': {
            backgroundColor: theme.palette.branded.darkGreenContentment,
            color: `white !important`,
          },
          '&.MuiChip-colorLightGrey': {
            backgroundColor: theme.palette.branded.lightGrey,
            color: `${theme.palette.branded.carbon} !important`,
          },
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: theme.palette.primary.main,
          },
          '&.MuiChip-colorSecondary': {
            borderColor: theme.palette.secondary.main,
          },
          '&.MuiChip-colorInfo': {
            color: `${theme.palette.info.main} !important`,
            borderColor: theme.palette.info.main,
          },
          '&.MuiChip-colorSuccess': {
            color: `${theme.palette.success.dark} !important`,
            borderColor: theme.palette.success.main,
          },
          '&.MuiChip-colorWarning': {
            color: `${theme.palette.warning.dark} !important`,
            borderColor: theme.palette.warning.main,
          },
          '&.MuiChip-colorError': {
            color: `${theme.palette.error.main} !important`,
            borderColor: theme.palette.error.main,
          },
          '&.MuiChip-colorDarkGreenContentment': {
            color: `${theme.palette.branded.darkGreenContentment} !important`,
            borderColor: theme.palette.branded.darkGreenContentment,
          },
          // Light grey is too pale for text, so only the border uses it
          '&.MuiChip-colorLightGrey': {
            color: `${theme.palette.branded.carbon} !important`,
            borderColor: theme.palette.branded.lightGrey,
          },
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
      },
    },
  };
}
